<script setup>
import { onMounted } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useWebSiteStore } from '@/stores/web-site.store'
import { useReadonlyField } from '@/composables/readonly-form'

const props = defineProps({
  modelValue: {
    type: [Number, String, null],
    required: false,
    default: null,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
  clearable: {
    type: Boolean,
    required: false,
    default: true,
  },
  options: {
    type: Array,
    required: false,
    default: null,
  },
})

const isReadonly = useReadonlyField(() => props.readonly)

const emit = defineEmits(['update:modelValue'])

const i18n = getI18n()
const webSiteStore = useWebSiteStore()

onMounted(async () => {
  await webSiteStore.fetchCurrenciesAsync({ all: true }, true)
})

const optionLabel = (opt) => opt?.code ? `${opt.code} - ${opt.name}` : opt?.name
</script>
<template>
  <q-select
    :model-value="props.modelValue"
    :options="props.options ?? webSiteStore.getLocalizedCurrencies()"
    :label="i18n.t('common.currency')"
    option-value="id"
    :option-label="optionLabel"
    emit-value
    map-options
    :clearable="props.clearable && !isReadonly"
    :readonly="isReadonly"
    @update:model-value="(val) => emit('update:modelValue', val)"
  />
</template>
